import { SafeImg } from "../../components/SafeImg";
import { Intro, Perks, SearchCard, useHero, useSlide } from "./parts";

export const BoutiqueHome = ({ data }) => {
  const [s, i] = useSlide(data.slides, 7000);
  const hero = useHero(data);
  const second = data.slides[(i + 1) % Math.max(1, data.slides.length)];
  return (
    <>
      <section className="container-x grid gap-12 pt-12 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:pt-20" data-testid="boutique-hero">
        <div>
          <p className="eyebrow !text-gold">{s.subtitle}</p>
          <h1 key={i} className="mt-4 animate-rise font-serif text-5xl italic leading-[1.02] text-ink sm:text-6xl lg:text-7xl" data-testid="hero-caption">{hero.headline || s.caption || data.brand.name}</h1>
          <div className="mt-6 h-px w-24 bg-gold" />
          <Intro text={hero.intro} className="text-ink/70" />
          <SearchCard title="Reserve your stay" compact className="mt-10 !rounded-none !border-gold/25" />
        </div>
        <div className="relative hidden h-[640px] lg:block">
          <SafeImg src={s.image} alt={s.caption} className="absolute right-0 top-0 h-[520px] w-[78%] object-cover" />
          {second && <SafeImg src={second.image} alt={second.caption} className="absolute bottom-0 left-0 h-[300px] w-[52%] border-8 border-sand object-cover" />}
        </div>
        <SafeImg src={s.image} alt={s.caption} className="h-72 w-full object-cover lg:hidden" />
      </section>
      <Perks variant="numbers" />
    </>
  );
};

export const SafariHome = ({ data }) => {
  const [s, i] = useSlide(data.slides);
  const hero = useHero(data);
  return (
    <>
      <section className="container-x pt-6" data-testid="safari-hero">
        <div className="relative h-[460px] overflow-hidden rounded-[calc(var(--r)*2)] sm:h-[540px]">
          {data.slides.map((sl, k) => (
            <img key={k} src={sl.image} alt={sl.caption} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[1400ms] ${k === i ? "opacity-100" : "opacity-0"}`} />
          ))}
          <div className="absolute inset-0 bg-gradient-to-t from-shade/75 via-shade/10 to-transparent" />
          <div className="absolute inset-3 rounded-[calc(var(--r)*1.6)] border border-paper/40" />
          <div className="absolute bottom-0 left-0 p-8 sm:p-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-paper/85">{s.subtitle}</p>
            <h1 key={i} className="mt-3 max-w-2xl animate-rise font-serif text-4xl text-paper sm:text-6xl" data-testid="hero-caption">{hero.headline || s.caption || data.brand.name}</h1>
          </div>
        </div>
      </section>
      <section className="container-x mt-12 grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="lg:pt-6">
          <p className="eyebrow !text-gold">{data.brand.name}</p>
          <p className="mt-3 font-serif text-3xl leading-snug text-ink">{data.brand.tagline || "Where the wild meets comfort."}</p>
          <p className="mt-4 whitespace-pre-line leading-relaxed text-ink/65" data-testid="hero-intro">{hero.intro || data.brand.footer_text}</p>
        </div>
        <SearchCard title="Find your room" compact className="!bg-linen" />
      </section>
      <Perks />
    </>
  );
};
